<template>
  <span>
    <div v-if="value.value.value" style="color: green">Ano</div>
    <div v-if="!value.value.value" style="color: red">Ne</div>
  </span>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'

export default {
    name: 'BooleanDetail',
    mixins: [
        DataTypeProsMixin,
    ],
}
</script>
